module.exports = __webpack_public_path__ + "static/ithaca-49a0664213e9c239df99ef28b86de21d.png";